import { render, staticRenderFns } from "./lamsRegLegalConsultSummary.vue?vue&type=template&id=2072f0f7&scoped=true&"
import script from "./lamsRegLegalConsultSummary.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalConsultSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072f0f7",
  null
  
)

export default component.exports